export const navMotion = {
	hidden: {
		opacity: 0,
		x: "100%",
		transition: {
			delay: 0.5,
			duration: 0.5,
			staggerChildren: 0.05,
			staggerDirection: -1,
		},
	},
	show: {
		opacity: 1,
		x: "0",
		transition: {
			duration: 0.5,
			staggerChildren: 0.07,
			delayChildren: 0.5,
		},
	},
};

export const linkMotion = {
	show: {
		y: 0,
		opacity: 1,
		transition: {
			y: { stiffness: 1000, velocity: -100 },
		},
	},
	hidden: {
		y: 50,
		opacity: 0,
		transition: {
			y: { stiffness: 1000 },
		},
	},
};

export const pageMotion = {
	hidden: {
		opacity: 0,
	},

	show: {
		opacity: 1,
		transition: {
			duration: 1,
			when: "beforeChildren",
			staggerChildren: 0.25,
		},
	},

	exit: {
		opacity: 0,
		transition: {
			duration: 1,
		},
	},
};

export const notification = {
	hidden: {
		y: -30,
		opacity: 0,
	},
	show: {
		y: 30,
		opacity: 1,
		transition: {
			duration: 1,
		},
	},
};

export const fadeInMotion = {
	hidden: {
		opacity: 0,
		transition: {
			duration: 0.75,
		},
	},
	show: {
		opacity: 1,
		transition: {
			duration: 0.5,
			when: "beforeChildren",
			staggerChildren: 0.5,
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.75,
		},
	},
};

export const expandMotion = {
	hidden: {
		scaleY: 0,
		transition: {
			duration: 0.75,
		},
	},
	show: {
		scaleY: 1,
		transition: {
			duration: 0.75,
		},
	},
	exit: {
		scaleY: 0,
		transition: {
			duration: 0.75,
		},
	},
};
